// extracted by mini-css-extract-plugin
module.exports = {"container":"i_A0","header":"i_A1","avatar":"i_A2","image":"i_A3","body":"i_A4","bubbles":"i_A5","plural":"i_A6","singular":"i_A7","bubble":"i_A8"};